import React, { useEffect } from 'react';
import { getConfig } from '../../apiConfig';
import { DiagConsoleLogger, DiagLogLevel, diag } from '@rtl_nl/rtl-otel-js-web';

const Chatbot = () => {
	const config = getConfig();
	const { statics_location } = config;

	diag.setLogger(new DiagConsoleLogger(), DiagLogLevel.DEBUG);

	useEffect(() => {
		// Listen for console.warn messages from the chatbot iframe
		const handleMessage = (event) => {
			if (event.data && event.data.type === 'CONSOLE_WARN') {
				const { message, args, timestamp } = event.data;

				// Convert message to readable string (handle objects)
				const messageString =
					typeof message === 'object' && message !== null
						? JSON.stringify(message)
						: String(message);

				// Convert args to string to avoid OpenTelemetry attribute errors
				const argsString = args && args.length > 0 ? JSON.stringify(args) : '';

				// Send to OpenTelemetry
				diag.warn(`[chatbot] ${messageString}`, {
					message: messageString,
					args: argsString,
					timestamp: String(timestamp),
					source: 'chatbot-iframe',
				});
			}
		};

		// Add event listener
		window.addEventListener('message', handleMessage);

		// Cleanup
		return () => {
			window.removeEventListener('message', handleMessage);
		};
	}, []);

	return (
		<>
			<iframe
				src={`${statics_location}/chatbot.html`}
				style={{ width: '100%', height: '100vh', border: 'none' }}
			/>
		</>
	);
};

export default Chatbot;
